import _ from 'lodash'
import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.array

// util function
function getNested (result, obj, depth) {
  obj.depth = depth = depth || 0
  result.push(obj)
  return _.reduce(obj.children, (childResult, child) => {
    child.parent = obj.value
    return getNested(childResult, child, depth + 1)
  }, result)
}

class ArrayEditor extends BaseEditor {
  constructor (options, defaults) {
    options = Object.assign(options, {
      collapsed: false
    })
    super(options, defaults)
  }

  postBuild () {
    super.postBuild()

    if (this.tabs_holder) {
      this.container.classList.add('je-array__tabs')
    }

    if (this.schema.format === 'tabs-top') {
      this.container.classList.add('je-array__tabs-top')
    }
  }

  addRow (value, initial) {
    const row = super.addRow(value, initial)

    if (row.delete_button) {
      const controlsHolder = row.title_controls || row.array_controls
      controlsHolder.appendChild(row.delete_button)
    }

    return row
  }

  getElementEditor (i) {
    const ret = super.getElementEditor(i)

    if (!ret.title_controls && ret.title) {
      ret.array_controls = this.theme.getButtonHolder()
      ret.title.appendChild(ret.array_controls)
    }

    if ((ret.schema.type === 'string' || ret.schema.type === 'number') &&
        (ret.schema.format === 'select' || ret.schema.format === 'choices')) {
      ret.container.classList.remove('card')
      ret.container.classList.remove('card-body')
      ret.container.classList.add('je-string__select')
    }

    return ret
  }

  getValue () {
    // check for dataset ref
    if (_.has(this.schema, 'options.dataset')) {
      if (this.jsoneditor.skipDatasets) {
        return []
      }
  
      const source = this.schema.options.dataset.split(':')
      const dataset = _.find(this.jsoneditor.options.datasets, { type: source[0], name: source[1] })
  
      if (dataset) {
        const data = _.get(dataset.data, source[2], [''])
  
        if (this.schema.options.flatten) {
          return _.reduce(data, (result, obj) => {
            return getNested(result, obj, 0)
          }, [])
        }
  
        return data
      }
    }
  
    if (_.has(this.schema, 'options.datasetSource')) {
      if (this.jsoneditor.skipDatasets) {
        return []
      }
  
      const sourceProp = this.schema.options.datasetSource
  
      // get value from sourceProp
      const source = this.jsoneditor.getEditor(sourceProp)
      const name = source ? source.getValue() : null
      const dataset = _.find(this.jsoneditor.options.datasets, { name })
  
      if (dataset) {
        return dataset.data
      }
    }
  
    if (!this.dependenciesFulfilled) {
      return undefined
    }
  
    return this.value
  }

  _createCopyButton (i, holder) {
    const button = super._createCopyButton(i, holder)
    button.classList.remove('btn-outline-secondary')
    button.classList.add('btn-secondary')
    return button
  }

  _createMoveUpButton (i, holder) {
    const button = super._createMoveUpButton(i, holder)
    button.classList.remove('btn-outline-secondary')
    button.classList.add('btn-secondary')
    return button
  }

  _createMoveDownButton (i, holder) {
    const button = super._createMoveDownButton(i, holder)
    button.classList.remove('btn-outline-secondary')
    button.classList.add('btn-secondary')
    return button
  }
}

export default ArrayEditor
